
import run from '../../utilities/run';
import render from "./../../utilities/render";
import $ from 'jquery';
import { militaryToPeriodTime } from "../../utilities/general";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";
const _ = require("underscore");
const reviewCalendarRows = require("./html/reviewCalendarRows.html");
const facCertNamesTemplateHtml = require('./html/rowTemplate.html');
const reviewSquareFootageHtml = require('./html/reviewSquareFootageDetailRow.html');
const utilizationPillTemplateHtml = require('./html/utilizationPillTemplate.html');

run("#spl-facilities-detailinfo-page", (mainEl) => {
  let editSPLFacilityId = mainEl.data("facility");
  const editSplFacilityUrl = mainEl.data("edit-splfacility-url");
  const portletNamespace = mainEl.data("portlet-namespace");
  const editSplFacilityBtn = mainEl.find(".edit-splfacility");
  let facViewJsonData = mainEl.data("facilityviewjson");
  let sqFtArea = mainEl.find("#facility-square-footage");
  let sfFtNotSetMsg = mainEl.find("#square-footage-not-set");
  let calendarNotSetMsg = mainEl.find(".calendar-view-not-set-msg");
  let calendarSetDiv = mainEl.find("#view-calendar-shift-times");
  let certNotSetMsg = mainEl.find("#detailsinfo-fac-no-cert-names");
  let certSetdiv = mainEl.find("#detailsinfo-fac-cert-names");
  const activateSplFacilityBtn = mainEl.find(".activate-facility-btn");
  const deactivateSplFacilityBtn = mainEl.find(".deactivate-facility-btn");
  const changeFacilityStatusUrl = mainEl.data("change-status-url");
  const pageReloadUrl = mainEl.data("detail-page-reload-url");
  let facilityAttributes = [];

  editSplFacilityBtn.on("click", function (e) {
    e.preventDefault();
    location.href = `${editSplFacilityUrl}&${portletNamespace}facilityIdForEdit=${editSPLFacilityId}`;
  });

  //Display calendar on details page in 12hrs format.
  if (facViewJsonData != null && facViewJsonData != ""
    && facViewJsonData.facilitiesCalendarSet != null && facViewJsonData.facilitiesCalendarSet != "") {
    let viewcalendarRowHtml = [];
    let viewcalendarTimes = [];
    let savedCalendarForDetails = new Map();

    

    viewcalendarTimes = facViewJsonData.facilitiesCalendarSet;
    (viewcalendarTimes).map((day) => {
      savedCalendarForDetails.set(day.facCalendarSequenceId, day.facCalendarDay);
    });

    let sortedCalMapAsc = new Map([...savedCalendarForDetails.entries()].sort()); //holds sorted calendar days
    sortedCalMapAsc.forEach((value, key) => {
      (viewcalendarTimes).map((day) => {
        if (value == day.facCalendarDay) {
          viewcalendarRowHtml.push(render(reviewCalendarRows, {
            key: _(`${day.facCalendarDay.toUpperCase()}`).capitalize(),
            shiftTime: `${militaryToPeriodTime(`${day.facCalendarStartTime}`)} - ${militaryToPeriodTime(`${day.facCalendarEndTime}`)}`
          }));
        }
      });
    });
    calendarSetDiv.append(viewcalendarRowHtml.join(""));
    calendarNotSetMsg.hide();
 
  } else {
    calendarNotSetMsg.show();
    calendarSetDiv.hide();
    
  }

  //Display certificates on details page.

  if (facViewJsonData != null && facViewJsonData != ""
    && facViewJsonData.facilitiesAttributesSet != null && facViewJsonData.facilitiesAttributesSet != "") {
    const facAttributesData = new Set(facViewJsonData.facilitiesAttributesSet);
    let savedCertificatesForDetails = []; //holds certificates in the order of insertion by user on ui.
    let savedCertFromDBForDetails = new Map();
    let savedCertSwitcheryVal = "no";
    let savedFacUse = [];

    for (let keyval of facAttributesData) {
      let arr_names = new Array(keyval);
      for (let j = 0; j < arr_names.length; j++) {
        let attrName;
        let attrValue;
        let attrId;
        for (let k of Object.keys(arr_names[j])) {
          if (k == "faaKey") {
            attrName = (arr_names[j])[k];
          } else if (k == "faaValue") {
            attrValue = (arr_names[j])[k];
          } else if (k == "faaId") {
            attrId = (arr_names[j])[k];
          }

        }
        if (attrName != null && attrValue != null) {
          if (attrName == "FAC_CERTIFICATES_FLAG_ATTR") {
            if (attrValue == "yes") {
              savedCertSwitcheryVal = attrValue;
            }
          } else if (attrName == "FAC_CERTIFICATE_ATTR") {
            savedCertFromDBForDetails.set(attrId, attrValue);
          } else if (attrName == "FAC_USE_ATTR") {
            savedFacUse.push(attrValue);
          }
        }
      }
    }

    if (savedCertSwitcheryVal == "yes") {
      if (savedCertFromDBForDetails != null) {
        let sortedCertMapAsc = new Map([...savedCertFromDBForDetails.entries()].sort());
        sortedCertMapAsc.forEach((value, key) => {
          savedCertificatesForDetails.push(value);
        });
      }
      const certificatesnames = (savedCertificatesForDetails).map((certificatename) => {
        return render(facCertNamesTemplateHtml, {
          text: certificatename
        });
      });

      certSetdiv.append(certificatesnames.join(''));
      certNotSetMsg.hide();
    } else {
      certNotSetMsg.show();
    }

    //facility uses logic to display on detailsinfo page.   
    let detailsinfofcyusedivtags = [];
    let hidefcyuses = [];
    detailsinfofcyusedivtags = mainEl.find(".fcyuse-detailsinfo-div")
    _.each(detailsinfofcyusedivtags, (el) => {
      if ((el.id).indexOf('-yes') > -1) {
        $(el).hide();
      }
      if ((el.id).indexOf('-no') > -1) {
        $(el).show();
      }
    });

    let expectedId;
    _.each(savedFacUse, (val) => {
      val = val.replace(" ", "");
      expectedId = `detailsinfo-facuse-${val}-yes`;

      _.each(detailsinfofcyusedivtags, (el) => {

        if (expectedId == (el.id)) {
          expectedId = expectedId.replace("yes", "no");
          hidefcyuses.push(expectedId);
          $(el).show();

        }

      });
    });
    _.each(hidefcyuses, (val) => {
      val = val.replace(" ", "");
      _.each(detailsinfofcyusedivtags, (el) => {
        if (val == (el.id)) {
          $(el).hide();
        }

      });
    });

  }

  if (!_(facViewJsonData.facilitiesAttributesSet).isEmpty()) {
    facilityAttributes = facViewJsonData.facilitiesAttributesSet;
  }
 
  const squareFootageAvailableData = facilityAttributes.filter(facility => facility.faaKey.match(/FAC_AVAILABLE/g));
  const squareFootageTotalData = facilityAttributes.filter(facility => facility.faaKey.match(/FAC_TOTAL/g));
  const squareFootageUtilizedData = facilityAttributes.filter(facility => facility.faaKey.match(/FAC_UTILIZED/g));
  const totalAvailable = squareFootageAvailableData.concat(squareFootageTotalData).concat(squareFootageUtilizedData);
  const ambientList = totalAvailable.filter(facAttr => facAttr.faaKey.match(/AMBIENT/g));
  const coolerList = totalAvailable.filter(facAttr => facAttr.faaKey.match(/COOLER/g));
  const freezerList = totalAvailable.filter(facAttr => facAttr.faaKey.match(/FREEZER/g));
  const tempControlledList = totalAvailable.filter(facAttr => facAttr.faaKey.match(/CONTROLLED_ROOM_TEMPERATURE/g));
  let masterSqFootData = [ambientList, tempControlledList,coolerList, freezerList ];
  let sqFtMap = [];

  masterSqFootData.map((data) => {
    if(data.length > 0) {
      sqFtMap.push(normalizeSqFootageData(data));
    }
  });


  let sqFtDataHtml = (sqFtMap).map((sqFtRow) => {
      return render(reviewSquareFootageHtml, {
        sqFtHeader: sqFtRow.sqFtHeader,
        total: sqFtRow.total,
        available: sqFtRow.available,
        utilizationPill: renderUtilizationPill(sqFtRow.utilized)
      });

  });

  if(sqFtMap.length) {
    sqFtArea.html(sqFtDataHtml.join(""));
    sfFtNotSetMsg.hide();
  } else {
    sfFtNotSetMsg.show();
    sqFtArea.html("");
  }
  
  function normalizeSqFootageData(data) {
    let sqFtRowData = [];
    data.map((dataEl) => {
      let sqFtHeader = _(dataEl.faaKey.split('_').splice(2, 1).join("")).capitalize();
      let category = dataEl.faaKey.split('_').splice(1, 1).join("");
      if (sqFtHeader == 'Controlled') {
        sqFtHeader = 'Controlled Room Temperature';
      }
      let sqFtObject = {};
      sqFtObject.sqFtHeader = sqFtHeader;
      sqFtObject[category.toLowerCase()] = dataEl.faaValue;
      sqFtRowData.push(sqFtObject);
    });
    let finalNormalized = { ...sqFtRowData[0], ...sqFtRowData[1], ...sqFtRowData[2] };
    return finalNormalized;
  }
  
  function renderUtilizationPill(utilization) {
    let pillClass = (utilization > 100) ? 'q-pill-red' : 'q-pill-white-and-blue';
    return render(utilizationPillTemplateHtml, {
      pillClass,
      utilization
    });
  }

  function deactiveFacilitySuccess(data){    
		if(data.status === "Success"){
			const detailUrlFullURL = pageReloadUrl;
			deActivateFacilityModal.showSuccessModal();
			setTimeout(function() {
			 location.href = detailUrlFullURL;
			},SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
		}else{
			deActivateFacilityModal.showFailureModal();
		}
	}

	function deactiveFacilityError(){
		deActivateFacilityModal.hideAllModals();
  }
  
  let deActivateFacilityModal = null;
	deactivateSplFacilityBtn.on("click", function(e){
		e.preventDefault();
		deActivateFacilityModal = new SubmitModalFlow({
      confirmModalTitle: 'Deactivate Facility',
      confirmModalBody: `<div class="q-pad-all-xl">Once updated, these changes will be reflected throughout the application.</div>`,
      confirmModalBtnText: 'Deactivate Facility',
      modalDialogClass: "q-modal-dialog-500",
      onConfirmClick: function(){
        deActivateFacilityModal.showLoadingModal();
        handleFacilityActivateDeactivate({url: changeFacilityStatusUrl, input: '0' , success:deactiveFacilitySuccess, error: deactiveFacilityError});
      }
	  });
    deActivateFacilityModal.init();
    deActivateFacilityModal.showConfirmModal();
  });

  activateSplFacilityBtn.on("click", function(e){
		e.preventDefault();
		deActivateFacilityModal = new SubmitModalFlow({
      confirmModalTitle: 'Activate Facility',
      confirmModalBody: `<div class="q-pad-all-xl">Once updated, these changes will be reflected throughout the application.</div>`,
      confirmModalBtnText: 'Activate Facility',
      modalDialogClass: "q-modal-dialog-500",
      onConfirmClick: function(){
        deActivateFacilityModal.showLoadingModal();
        handleFacilityActivateDeactivate({url: changeFacilityStatusUrl, input: '1' , success:deactiveFacilitySuccess, error: deactiveFacilityError});
      }
	  });
    deActivateFacilityModal.init();
    deActivateFacilityModal.showConfirmModal();
  });
  
  function handleFacilityActivateDeactivate({url, input, success, error}){    
		$.ajax({
			url: url,
			data:{"status" : input},
			dataType:"JSON",
			type: 'POST',
			success: success,
			error: error
    });    
  }

});


// WEBPACK FOOTER //
// ./src/pages/standardPlatformFacilitySetupWizard/detailsInfo.js